import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { faqs, AMAZON_URL } from '../data/content';

const { FiChevronDown } = FiIcons;

// FAQ-Accordion (zugänglich über aria-expanded)
function Faq() {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="bg-white py-16">
      <div className="mx-auto max-w-3xl px-4">
        <h2 className="text-3xl font-extrabold">Häufige Fragen zum Auswandern in die Schweiz</h2>
        <div className="mt-8 divide-y divide-gray-200 rounded-2xl border border-gray-200">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <article key={f.q}>
                <h3>
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    aria-controls={`faq-${i}`}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left font-bold hover:text-[#D52B1E]"
                  >
                    {f.q}
                    <SafeIcon icon={FiChevronDown} className={`flex-none transition ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" />
                  </button>
                </h3>
                <div id={`faq-${i}`} hidden={!isOpen} className="px-5 pb-5 text-gray-700">
                  {f.a}
                  {f.link && (
                    <> <a href={AMAZON_URL} target="_blank" rel="noopener" className="font-semibold text-[#1E3A8A] underline">Zum Buch bei Amazon</a></>
                  )}
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Faq;